import { defaultApiClient } from "../libs";

export const verifyServiceId = async (serviceId) => {
  return await defaultApiClient.get(`/api/v1/services/verify`, {
    headers: {
      'X-SERVICE-ID': serviceId
    }
  })
}
